import React from 'react';
import '../styles/LandingPage.css';

const IntegrationsPage = () => {
  return (
    <section id="integrations" className="integrations-section">
      <div className="coming-soon-container">
        <h2 className="coming-soon-heading">Coming Soon...</h2>
        <p className="coming-soon-description">
          We're working on exciting integrations to enhance your workflow. Stay tuned!
        </p>
      </div>
    </section>
  );
};

export default IntegrationsPage;
